import { render } from "./PenaltyZone.vue?vue&type=template&id=4b8b6171"
import script from "./PenaltyZone.vue?vue&type=script&lang=js"
export * from "./PenaltyZone.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__